import React from 'react';

export const attachPropsToChild = ({
  child,
  props,
}: {
  child: React.ReactNode;
  props: Record<string, any>;
}): React.ReactNode =>
  React.isValidElement(child) ? React.cloneElement(child, { ...props }) : child;
